import { Input, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {

  transform(value: string , length: number = 32): string {
    if (value.length > length) {
      return value.substring(0, length - 1) + '\u2026';
    }
    return value;
  }
}
